const scriptCache = {};

export const loadScript = src => {
    if (scriptCache[src]) return scriptCache[src];

    const scriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');

        script.src = src;
        script.onload = event => resolve(event);
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
        document.head.appendChild(script);
    });

    scriptCache[src] = scriptPromise;

    return scriptPromise;
};
